import React, { useState, useEffect, lazy, Suspense } from '../../../_snowpack/pkg/react.js';
import styled from '../../../_snowpack/pkg/styled-components.js';
import hotkeys from '../../../_snowpack/pkg/hotkeys-js.js';
import { colors } from '../../css/index.js';
const Inner = /*#__PURE__*/lazy(() => import("./inner.js"));
const Outer = styled.aside.withConfig({
  displayName: "debug-bar__Outer",
  componentId: "agbim2-0"
})(["position:fixed;bottom:0;left:0;width:100%;background:", ";z-index:10;"], colors.frostbite);
const Title = styled.div.withConfig({
  displayName: "debug-bar__Title",
  componentId: "agbim2-1"
})(["position:absolute;bottom:100%;left:0;width:100%;text-align:center;"]);
const TitleBtn = styled.button.withConfig({
  displayName: "debug-bar__TitleBtn",
  componentId: "agbim2-2"
})(["appearance:none;padding:10px 15px;background:", ";color:#fff;border:none;font-size:inherit;cursor:pointer;border-radius:5px 5px 0 0;"], colors.frostbite);

function DebugBar() {
  const [shown, setShown] = useState(false);
  const keyPattern = 'option+d+b';
  useEffect(() => {
    function onKeyMatch() {
      setShown(!shown);
    }

    hotkeys(keyPattern, onKeyMatch);
    return () => hotkeys.unbind(keyPattern, onKeyMatch);
  });

  if (!shown) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Outer, null, /*#__PURE__*/React.createElement(Title, null, /*#__PURE__*/React.createElement(TitleBtn, {
    type: "button",
    onClick: () => setShown(false)
  }, "Developer debugger")), /*#__PURE__*/React.createElement(Suspense, {
    fallback: /*#__PURE__*/React.createElement("div", null, "...")
  }, /*#__PURE__*/React.createElement(Inner, null)));
}

export default DebugBar;